import styled from 'styled-components';
import { px2rem, getSpace } from '../../../stylesheets/tools';

const StyledCloseModal = styled.div`
  display: flex;
  justify-content: end;
  margin-bottom: ${getSpace('m')};
  position: sticky;
  top: 20px;
  z-index: 5;

  .close-modal__icon {
    padding: ${px2rem('8px')} ${px2rem('10px')};
    border-radius: ${px2rem('4px')};
    background-color: black;

    svg {
      color: white;
    }
  }
`;

export default StyledCloseModal;
